/**
 * Represents authorized permissions a user can take.
 */
export enum Action {
  /**
   * The user may view content on a board.
   */
  read = 'read',
  /**
   * The user may edit, add and delete content on a board.
   */
  write = 'write',
  /**
   * User can add comments to this whiteboard
   */
  'add/comment' = 'add/comment',
  /**
   * User can remove comments from this whiteboard
   */
  'delete/comment' = 'delete/comment',
  /**
   * User can export this whiteboard
   */
  'export' = 'export',
  /**
   * User can download attachments on this whiteboard
   */
  'download/attachment' = 'download/attachment',
}

export const isAction = (action: any): action is Action => {
  return typeof action === 'string' && action in Action;
};

/**
 * Returns a compact string representation of the current permissions a user has.
 * @example read -> r
 * @example read, write -> rw
 * @example empty -> -
 * @param actions
 * @returns string summary of current user permissions
 */
export const compact = (actions: Set<Action> | Array<Action>) => {
  let str = '';

  for (const action of actions) {
    if (action === Action.read) {
      str += 'r';
    }
    if (action === Action.write) {
      str += 'w';
    }
    if (action === Action['add/comment']) {
      str += 'ac';
    }
    if (action === Action['delete/comment']) {
      str += 'dc';
    }
    if (action === Action['export']) {
      str += 'ex';
    }
    if (action === Action['download/attachment']) {
      str += 'da';
    }
  }

  if (str.length === 0) {
    return '-';
  }
  return str;
};
